// extracted by mini-css-extract-plugin
export default {"container":"Screensaver_container__UxTNS"};